module.exports = new __parcel__URL__("What capabilities are your your top priorities to apply to different scopes_ v1.8d24db33.svg").toString();